/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreatorDto } from './creator-dto';
import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
import { MobilityDto } from './mobility-dto';
import { SessionExerciseDto } from './session-exercise-dto';
import { SessionReferencesDto } from './session-references-dto';
 /**
 *
 *
 * @export
 * @interface SessionUpdateResponseDto
 */
export interface SessionUpdateResponseDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof SessionUpdateResponseDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionUpdateResponseDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionUpdateResponseDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof SessionUpdateResponseDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof SessionUpdateResponseDto
     */
    title: string;

    /**
     * @type {number}
     * @memberof SessionUpdateResponseDto
     */
    laps: number;

    /**
     * @type {number}
     * @memberof SessionUpdateResponseDto
     */
    rest: number;

    /**
     * @type {MobilityDto}
     * @memberof SessionUpdateResponseDto
     */
    mobility?: MobilityDto | null;

    /**
     * @type {boolean}
     * @memberof SessionUpdateResponseDto
     */
    isProtocol: boolean;

    /**
     * @type {boolean}
     * @memberof SessionUpdateResponseDto
     */
    isTemplate: boolean;

    /**
     * @type {EnShared}
     * @memberof SessionUpdateResponseDto
     */
    shared: EnShared;

    /**
     * @type {number}
     * @memberof SessionUpdateResponseDto
     */
    duration: number;

    /**
     * @type {string}
     * @memberof SessionUpdateResponseDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionUpdateResponseDto
     */
    client: JoinEntityDto;

    /**
     * @type {CreatorDto}
     * @memberof SessionUpdateResponseDto
     */
    creator: CreatorDto;

    /**
     * @type {Array<SessionExerciseDto>}
     * @memberof SessionUpdateResponseDto
     */
    exercises: Array<SessionExerciseDto>;

    /**
     * The scheduled references the chosen strategy acted on: rewritten under `propagate`, detached (frozen) under `keep-scheduled`. Absent when the session had nothing scheduled.
     *
     * @type {SessionReferencesDto}
     * @memberof SessionUpdateResponseDto
     */
    propagation?: SessionReferencesDto;
}
